// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3ka8I","filesListContainer":"PosDisputesFiles_filesListContainer__15OPI","filesButton":"PosDisputesFiles_filesButton__2j8jX"};